const squares = [
    {
      id: 1,
      bgcolor: "qc-black",
    },
    {
      id: 2,
      bgcolor: "qc-yellow",
    },
    {
      id: 3,
      bgcolor: "qc-blue",
    },
    {
      id: 4,
      bgcolor: "qc-green",
    },
    {
      id: 5,
      bgcolor: "qc-red",
    },
    {
      id: 6,
      bgcolor: "qc-violet",
    },
  ];

  export default squares;
